import {
  EntryPointVariation,
  IntroPageVariation,
  PackingSuppliesVariations,
  StarterKitVariation,
} from '@updater-apps/packing-supplies/interactors/types/constants';
import { PackingSuppliesState } from './types/state';

/**
 * @function
 * @name formData
 * @description
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {Object} state
 */
export function formData(state: PackingSuppliesState) {
  return state;
}

/**
 * @function
 * @name packingSuppliesStatus
 * @description status of packing supplies
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {string} status
 */
export function packingSuppliesStatus(state: PackingSuppliesState): string {
  return state.status;
}

/**
 * @function
 * @name packingSuppliesVariation
 * @description get optimizely card variation selector
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {string} card variation - defaults to control
 */
export function packingSuppliesVariation(state: PackingSuppliesState): string {
  return state.variation || PackingSuppliesVariations.CONTROL;
}

/**
 * @function
 * @name introPageVariation
 * @description optimizely intro page variation selector
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {string} intro page variation - defaults to control
 */
export function introPageVariation(state: PackingSuppliesState): string {
  return state.introPageVariation || IntroPageVariation.CONTROL;
}

/**
 * @function
 * @name entryPointVariation
 * @description optimizely entry point variation selector
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {string} entry point variation - defaults to control
 */
export function entryPointVariation(state: PackingSuppliesState): string {
  return state.entryPointVariation || EntryPointVariation.CONTROL;
}

/**
 * @function
 * @name starterKitVariation
 * @description optimizely starter kit variation selector
 * @param {PackingSuppliesState} state - packing supplies store state
 * @returns {string} starter kit variation - defaults to control
 */
 export function starterKitVariation(state: PackingSuppliesState): string {
  return state.starterKitVariation || StarterKitVariation.CONTROL;
}
